module.exports = __webpack_public_path__ + "img/CgAG0mPyzdGAQqQ1AAS0tcj7lmc332.16b3369a.png";